import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    ButtonGroup,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Card,
    CardBody,
    CardHeader,
    CardFooter
} from 'reactstrap';
import {
    reactSelectOptionDiffrentPro,
} from '../../../../../helpers/Utils';
import Select from 'react-select';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
import country from '../../../../../data/country';
import Languages from '../../../../../data/languages';
import NudgeList from '../../../../../data/NudgeList';

const suitabilityData = [
    { label: "Business Traveler", value: "Business Traveler", key: 0 },
    { label: "Vacationing Families", value: "Vacationing Families", key: 1 },
    { label: "Couples", value: "Couples", key: 2 },
    { label: "Solo Traveler", value: "Solo Traveler", key: 3 },
    { label: "Friends or a Group", value: "Friends or a Group", key: 4 },
];
export function RuleActions({ liveChatSetting, servicesList, servicesOfferDealList, visible, toggle, submit, updateData }) {
    const [isLiveChatVisible, setIsLiveChatVisible] = useState(false);
    const [isaivaSignUpVisible, setIsaivaSignUpVisible] = useState(false);
    const [actionInputData, setActionInputData] = useState([{
        nudge: "0",
        text: "",
        value: "",
        service: [],
        nudgeButton: {
            delayInMilliseconds: 0,
            buttons: []
        },
        suitability: []
    }]);
    const [selectedService, setSelectedService] = useState([]);
    const [selectedOffer, setSelectedOffer] = useState([]);
    const [selectedSuitability, setSelectedSuitability] = useState([]);

    useEffect(() => {
        if (updateData[0].action.length > 0) {
            var services = [];
            var serviceOffer = [];
            var suitability = [];
            updateData[0].action.map(i => {
                if (i.nudge === "Offer Package or a Deal") {
                    if (i.service && i.service.length > 0) {
                        i.service.map((serv) => servicesOfferDealList.filter((e) => e.id === serv.id).map(items =>
                            serviceOffer.push({
                                value: items.id,
                                label: items.title
                            })
                        ))
                    }
                }
                else if (i.nudge === "Promote Product Service or Activity") {
                    if (i.service && i.service.length > 0) {
                        i.service.map((serv) => servicesList.filter((e) => e.id === serv.id).map(items =>
                            services.push({
                                value: items.id,
                                label: items.title
                            })
                        ))
                    }
                }
                else if (i.nudge === "Assign Customer Segment") {
                    if (i.suitability !== null && i.suitability.length > 0) {
                        i.suitability.map((item) =>
                            suitability.push(
                                suitabilityData.filter((cat) => cat.value === item)[0]
                            )
                        );
                    }
                }
            });
            let actionBody = [];
            updateData[0].action.map((item) => {
                let nudgeBtnBody = {};
                if (item.nudge === "Nudge with a text message") {
                    nudgeBtnBody = {
                        delayInMilliseconds: item.nudgeButton.delayInMilliseconds / 1000,
                        buttons: item.nudgeButton.buttons
                    }
                }
                actionBody.push({
                    nudge: item.nudge,
                    nudgeButton: nudgeBtnBody,
                    service: item.service,
                    suitability: item.suitability === null ? [] : item.suitability,
                    text: item.text,
                    value: item.value
                })
            })
            setSelectedSuitability(suitability);
            setSelectedOffer(serviceOffer);
            setSelectedService(services);
            setActionInputData(actionBody);
        }
        else {
            const values = [];
            values.push({
                nudge: ""
            });
            setActionInputData(values);
        }
    }, [updateData]);
    const handleAddNudgeButton = (e, index) => {
        const values = [...actionInputData];
        let body = {
            text: "",
            value: ""
        };
        if (values[index].nudgeButton.buttons === null) {
            values[index].nudgeButton.buttons = [body];
        }
        else {
            values[index].nudgeButton.buttons.push(body);
        }
        setActionInputData(values);
    };
    const handleChangeNudge = (e, index, itemIndex) => {
        const values = [...actionInputData];
        if (e.target.name == "delayInMilliseconds") {
            values[index].nudgeButton.delayInMilliseconds = e.target.value;
            if (values[index].nudgeButton.buttons !== null && values[index].nudgeButton.buttons.length === 0) {
                values[index].nudgeButton.buttons = [];
            }
        } else {
            if (e.target.name === "text") {
                values[index].nudgeButton.buttons[itemIndex].text = e.target.value;
            } else {
                values[index].nudgeButton.buttons[itemIndex].value = e.target.value;
            }
        }
        setActionInputData(values)
    }
    const handleRemoveNudgeFields = (index, itemIndex) => {
        const values = [...actionInputData];
        values[index].nudgeButton.buttons.splice(itemIndex, 1);
        setActionInputData(values);
    }
    const toggleAction = () => {
        toggle();
    }
    const handleChangeAction = (e, index) => {
        const values = [...actionInputData];
        const nudgetext = values[index].nudge;
        if (e.target.name === "nudge") {
            values[index].service = [];
            values[index].suitability = [];
            values[index].value = "";
            values[index].text = "";
            values[index].nudgeButton = {};
            if (e.target.value === "Offer Live Chat") {
                if (liveChatSetting.enabled === false) { toggleLiveChat(); }
                else { values[index].nudge = e.target.value; }
            }
            else if (e.target.value === "Offer a Voucher") {
                toggleSignUp();
            }
            else if (e.target.name === "Nudge with a text message") {
                values[index].nudgeButton = {
                    delayInMilliseconds: 0,
                    buttons: []
                };
            }
            else {
                values[index].nudge = e.target.value;
            }
        }
        else {
            values[index].text = e.target.value;

            if (nudgetext === "Offer Live Chat") {
                values[index].value = "Human Chat";
            }
            else {
                values[index].value = "";
            }
        }
        setActionInputData(values);
    }
    const handleChangeSelect = (selectedOptions, index, name) => {
        let serv = [];
        if (name === "offerservice") {
            selectedOptions.map((a) => serv.push({ id: a.value, title: a.label }));
            setSelectedOffer(selectedOptions.value);
        }
        else if (name === "service") {
            selectedOptions.map((a) => serv.push({ id: a.value, title: a.label }));
            setSelectedService(selectedOptions.value);
        }
        const values = [...actionInputData];
        values[index].service = serv;
        values[index].suitability = [];
        values[index].text = "";
        values[index].value = "";
        setActionInputData(values);
    };
    const handleMoreAction = (e) => {
        const values = [...actionInputData];
        values.push({
            nudge: ""
        });
        setActionInputData(values);
    };
    const handleRemoveAction = (index) => {
        const values = [...actionInputData];
        values.splice(index, 1);

        setTimeout(() => {
            setActionInputData(values);
        }, 1000);
    }
    const toggleLiveChat = () => {
        setIsLiveChatVisible(!isLiveChatVisible);
    }
    const handleGoToSetting = () => {
        toggleLiveChat();
        toggleAction();
    };
    const liveChatPopup = () => {
        return (
            <Fragment>
                <Modal isOpen={isLiveChatVisible} toggle={toggleLiveChat}>
                    <ModalBody>
                        <div className="text-center">
                            <h3>Live Chat</h3>
                            <p style={{ marginTop: "20px" }}>Please ensure that Live Chat is enabled</p>
                            <Button style={{ marginTop: "20px" }}
                                color="primary"
                                onClick={() => handleGoToSetting()}
                                size="xs"
                            >
                                Go to Settings
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>
            </Fragment>);
    };
    const toggleSignUp = () => {
        setIsaivaSignUpVisible(!isaivaSignUpVisible);
    };
    const handleSignUpAiva = () => {
        window.location.href = "https://app.getaiva.com/users/vouchersignup";
    }
    const aivaSignupPopup = () => {
        return (
            <Fragment>
                <Modal isOpen={isaivaSignUpVisible} toggle={toggleSignUp}>
                    <ModalBody>
                        <div className="text-center">
                            <h3>Sign up to <b>aiva</b></h3>
                            <p style={{ marginTop: "20px" }}>
                                It's quick,inexpensive,simple and smart, Ten minutes is all <br />
                                it takes to sign-up and upload your first voucher.
                            </p>
                            <Button style={{ marginTop: "20px" }}
                                color="primary"
                                onClick={() => handleSignUpAiva()}
                                size="xs"
                            >
                                Learn More
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>
            </Fragment>
        );
    };

    const handleSubmitAction = () => {
        const values = [...actionInputData];
        let body = [];
        values.map((item) => {
            let buton = {};
            if (item.nudge === "Nudge with a text message") {
                let nudgbtn = [];
                if (item.nudgeButton.buttons !== null) {
                    item.nudgeButton.buttons.map(btn => (
                        nudgbtn.push({
                            text: btn.text,
                            value: btn.value
                        })
                    ));
                }
                buton = {
                    delayInMilliseconds: item.nudgeButton.delayInMilliseconds * 1000,
                    buttons: nudgbtn
                }

            }
            body.push({
                nudge: item.nudge,
                nudgeButton: buton,
                service: item.service,
                text: item.text,
                value: item.value,
                suitability: item.suitability
            });

        })
        updateData[0].action = body;
        toggleAction();
        submit(updateData);
    }
    const handleChangeMultiSuitability = (selectedSuitability, index) => {
        setSelectedSuitability(selectedSuitability);
        const suitabilityArr = selectedSuitability.map((elem) => elem.value);
        const value = [...actionInputData];
        value[index].suitability = suitabilityArr;
        setActionInputData(value);
    };
    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggleAction} size="lg">
                <ModalHeader toggle={toggleAction}>Add Engagement Actions</ModalHeader>
                <ModalBody>
                    <Row className="mb-4">
                        <Colxx xxs="12">
                            {actionInputData && actionInputData.map((item, index) => (
                                <Card key={index}>
                                    <CardBody>
                                        <Row>
                                            {index !== 0 && (
                                                <Colxx sm={12} className="mb-6 text-right">
                                                    <Button
                                                        onClick={() =>
                                                            handleRemoveAction(index)
                                                        }
                                                        color="secondary"
                                                        size="xs"
                                                        outline
                                                        style={{ margin: '6px' }}
                                                    >
                                                        -
                                                    </Button>
                                                </Colxx>
                                            )}
                                            <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                                <Input
                                                    type="select"
                                                    value={item.nudge}
                                                    name="nudge"
                                                    onChange={(e) => handleChangeAction(e, index)}
                                                >
                                                    {NudgeList.map((elem, i) => (
                                                        <option key={i} value={elem.value}>
                                                            {elem.label}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Colxx>
                                            {item.nudge !== "0" && item.nudge !== "" && (
                                                <Fragment>
                                                    {item.nudge === "Promote Product Service or Activity" ? (
                                                        <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                                            <Select
                                                                isMulti={true}
                                                                className="react-select"
                                                                classNamePrefix="react-select"
                                                                name="service"
                                                                options={
                                                                    servicesList
                                                                        ? reactSelectOptionDiffrentPro(
                                                                            servicesList,
                                                                            true,
                                                                            'id',
                                                                            'title',
                                                                            'All service'
                                                                        )
                                                                        : []
                                                                }
                                                                placeholder="Service"
                                                                value={selectedService}
                                                                onChange={(e) => handleChangeSelect(e, index, "service")}
                                                            />
                                                        </Colxx>
                                                    ) :
                                                        item.nudge === "Offer Package or a Deal" ? (
                                                            <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                                                <Select
                                                                    isMulti={true}
                                                                    className="react-select"
                                                                    classNamePrefix="react-select"
                                                                    name="offerservice"
                                                                    options={
                                                                        servicesOfferDealList
                                                                            ? reactSelectOptionDiffrentPro(
                                                                                servicesOfferDealList,
                                                                                true,
                                                                                'id',
                                                                                'title',
                                                                                'All service'
                                                                            )
                                                                            : []
                                                                    }
                                                                    placeholder="Offer Package or a Deal"
                                                                    value={selectedOffer}
                                                                    onChange={(e) => handleChangeSelect(e, index, "offerservice")}
                                                                />
                                                            </Colxx>
                                                        ) : item.nudge === "Assign Customer Segment" ? (
                                                            <Colxx sm={12}>
                                                                <Label>Suitability</Label>
                                                                <Select
                                                                    components={{ Input: CustomSelectInput }}
                                                                    className="react-select"
                                                                    classNamePrefix="react-select"
                                                                    isMulti={true}
                                                                    name="form-field-name"
                                                                    value={selectedSuitability}
                                                                    onChange={(e) => handleChangeMultiSuitability(e, index)}
                                                                    options={suitabilityData}
                                                                />
                                                            </Colxx>
                                                        ) : (
                                                            <Fragment>
                                                                <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                                                    <Input
                                                                        type="text"
                                                                        value={item.text}
                                                                        name="text"
                                                                        placeholder="Nudge Text"
                                                                        onChange={(e) => handleChangeAction(e, index)}></Input>
                                                                </Colxx>
                                                                {item.nudge === "Nudge with a text message" && (
                                                                    <Fragment>
                                                                        <Colxx sm={3} style={{ marginBottom: "10px" }}>
                                                                            <Label>Delay in Seconds</Label>
                                                                            <Input
                                                                                type="number"
                                                                                min="0"
                                                                                value={item.nudgeButton ?
                                                                                    item.nudgeButton.delayInMilliseconds
                                                                                    : 0}
                                                                                name="delayInMilliseconds"
                                                                                onChange={(event) => handleChangeNudge(event, index)}
                                                                            />
                                                                        </Colxx>
                                                                        <Colxx sm={12}>
                                                                            <Row>
                                                                                <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                                                                    <Label>Buttons</Label>

                                                                                </Colxx>
                                                                            </Row>
                                                                            {item.nudgeButton && item.nudgeButton.buttons &&
                                                                                item.nudgeButton.buttons.map((nudge, btnindex) => (
                                                                                    <Row key={btnindex}>
                                                                                        <Colxx sm={3} style={{ marginBottom: "10px" }}>
                                                                                            <Label>Text</Label>
                                                                                            <Input
                                                                                                type="text"
                                                                                                name="text"
                                                                                                value={nudge.text}
                                                                                                onChange={(event) => handleChangeNudge(event, index, btnindex)}
                                                                                            />
                                                                                        </Colxx>
                                                                                        <Colxx sm={3} style={{ marginBottom: "10px" }}>
                                                                                            <Label>Value</Label>
                                                                                            <Input
                                                                                                type="text"
                                                                                                name="value"
                                                                                                value={nudge.value}
                                                                                                onChange={(event) => handleChangeNudge(event, index, btnindex)}
                                                                                            />
                                                                                        </Colxx>
                                                                                        <Colxx sm={1} style={{ marginBottom: "10px" }}>
                                                                                            <Label>Remove</Label>
                                                                                            <div>
                                                                                                <Button
                                                                                                    onClick={() => handleRemoveNudgeFields(index, btnindex)}
                                                                                                    color="secondary"
                                                                                                    size="xs"
                                                                                                    outline
                                                                                                    style={{ margin: '6px' }}
                                                                                                >
                                                                                                    -
                                                                                                </Button>
                                                                                            </div>
                                                                                        </Colxx>
                                                                                    </Row>))}
                                                                            <Button
                                                                                onClick={(e) => handleAddNudgeButton(e, index)}
                                                                                color="primary"
                                                                                size="xs"
                                                                                outline
                                                                                style={{ margin: '6px' }}
                                                                            >
                                                                                + Add Button
                                                                            </Button>
                                                                        </Colxx>
                                                                    </Fragment>
                                                                )}
                                                            </Fragment>
                                                        )}
                                                </Fragment>
                                            )}
                                        </Row>
                                    </CardBody>
                                </Card>
                            ))}
                        </Colxx>
                        <Colxx sm={6} className="mb-6">
                            <Button
                                onClick={(e) => handleMoreAction(e)}
                                color="secondary"
                                size="xs"
                                outline
                                style={{ margin: '6px' }}
                            >
                                + Action
                            </Button>
                        </Colxx>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary"
                        onClick={handleSubmitAction}
                    >
                        Create
                    </Button>
                    <Button color="secondary" onClick={toggleAction}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            {liveChatPopup()}
            {aivaSignupPopup()}
        </Fragment>
    );
};